import { Route, Routes } from "react-router-dom";
import { SONOMETER_PATH } from "_urls";
import { SonometerScreencastView } from "../screencast/views/SonometerScreencastView";

export function SonometerScreencastRoutes() {
  return (
    <Routes>
      <Route
        path={`${SONOMETER_PATH}/:sonometerId`}
        element={<SonometerScreencastView />}
      />
    </Routes>
  );
}
